import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { TripInformationConstants } from '../../tripInformation/store/tripInformation.constants'
import { getTripInformationSelector } from '../../tripInformation/selectors'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { getCmsInformationOptionsSelector } from '../../options/selectors'
import { ICmsInformationOptionsState } from '../../options/store/options.types'
import { setFilteredCmsConditionCodeOptions as setFilteredCmsConditionCodeOptionsAction } from '../../options/store/options.actions'
import { IOptions } from '../../../common/common.types'
import { OptionsConstants } from '../../options/store/options.constants'

export function* setFilteredCmsConditionCodeOptions() {
  const tripInformationState: ITripInformationState = yield select(getTripInformationSelector)
  const { staffingLevel } = tripInformationState

  const cmsInformationOptionState: ICmsInformationOptionsState = yield select(getCmsInformationOptionsSelector)
  const { cmsConditionCodeOptions } = cmsInformationOptionState

  const searchTerm = [
    'BLS',
    'BLS - AEMT',
    'BLS - Basic/EMT',
    'BLS - First Responder/EMR',
    'BLS - Intermediate',
    'BLS-Community Paramedicine',
    'Comm Center',
    'Fire',
    'First Responder',
    'Hazmat',
    'Police',
    'Rescue',
  ]
  const mandateOptions = ['Not Applicable', 'Not Available', 'Not Known', 'Not Reporting']
  try {
    if (cmsConditionCodeOptions && cmsConditionCodeOptions.length) {
      const options: IOptions = []
      cmsConditionCodeOptions.forEach((conditionCodeObj) => {
        if (staffingLevel && staffingLevel.name && searchTerm.includes(staffingLevel.name)) {
          if (mandateOptions.includes(conditionCodeObj.name || '') || conditionCodeObj.name?.includes('BLS')) {
            options.push({ id: conditionCodeObj.id, name: conditionCodeObj.name })
          }
        } else {
          options.push({ id: conditionCodeObj.id, name: conditionCodeObj.name })
        }
      })
      yield put(setFilteredCmsConditionCodeOptionsAction(options))
    }
  } catch (e) {
    yield put(throwPcrException(`setFilteredCmsConditionCodeOptions() error: ${e}`))
  }
}

export function* setFilteredCmsConditionCodeOptionsSaga() {
  yield takeLatest(
    [TripInformationConstants.SET_STAFFING_LEVEL, OptionsConstants.SET_CMS_CONDITION_CODE_OPTIONS],
    setFilteredCmsConditionCodeOptions
  )
}
